import { c as _c } from "react/compiler-runtime";
import { CheckBox, Typography } from "../../atoms";
import { FilterValue } from "@/shared/types/type/search";
import { useSearchUiStore } from "@/features/search/model/ui/store";
import { getRegionAllOption } from "@/features/search-result/lib/regionAllOption";
interface RegionModalContentProps {
  selectedRegion: number;
  selectedSubRegions: FilterValue[];
  setSelectedSubRegions: (selectedSubRegions: FilterValue[]) => void;
  hideRegionAllOption?: boolean;
}
const RegionModalContent = t0 => {
  const $ = _c(21);
  const {
    selectedRegion,
    selectedSubRegions,
    setSelectedSubRegions,
    hideRegionAllOption: t1
  } = t0;
  const hideRegionAllOption = t1 === undefined ? false : t1;
  const {
    regionList
  } = useSearchUiStore();
  let t2;
  let t3;
  let t4;
  if ($[0] !== hideRegionAllOption || $[1] !== regionList || $[2] !== selectedRegion || $[3] !== selectedSubRegions || $[4] !== setSelectedSubRegions) {
    let t5;
    if ($[8] !== selectedRegion) {
      t5 = region => region.id === selectedRegion;
      $[8] = selectedRegion;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    const parentRegion = regionList.find(t5);
    const rawSubRegions = parentRegion?.children ?? [];
    const subRegions = hideRegionAllOption ? rawSubRegions.slice(1) : rawSubRegions;
    const allLabel = hideRegionAllOption ? undefined : getRegionAllOption(parentRegion);
    const isSubRegionIncluded = _temp;
    const isAllSelected = allLabel ? isSubRegionIncluded(selectedSubRegions, allLabel) : false;
    let t6;
    if ($[10] !== selectedSubRegions || $[11] !== setSelectedSubRegions) {
      t6 = region_1 => {
        if (isSubRegionIncluded(selectedSubRegions, region_1) && selectedSubRegions.length === 1) {
          setSelectedSubRegions([]);
          return;
        }
        setSelectedSubRegions([region_1]);
      };
      $[10] = selectedSubRegions;
      $[11] = setSelectedSubRegions;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    const replaceWithSingle = t6;
    const allCheck = () => {
      if (allLabel) {
        replaceWithSingle(allLabel);
      }
    };
    let t7;
    if ($[13] !== replaceWithSingle) {
      t7 = region_2 => {
        replaceWithSingle(region_2);
      };
      $[13] = replaceWithSingle;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    const checkSubRegions = t7;
    t4 = "min-h-0 w-3/5 flex-1 overflow-y-auto";
    t2 = "flex flex-col";
    t3 = subRegions.map((region_3, index) => {
      const isAllOption = !hideRegionAllOption && index === 0;
      const isChecked = isAllOption ? isAllSelected : isSubRegionIncluded(selectedSubRegions, region_3) && !isAllSelected;
      return <li key={`${region_3.name}-${index}`} className="py-3 pl-4"><label className="flex items-center gap-2 cursor-pointer"><CheckBox checked={isChecked} checkedColor="#6B00D7" width={16} height={16} border={{
            color: "#E5E6EB",
            borderWidth: "2px",
            radius: "2px"
          }} onChange={() => isAllOption ? allCheck() : checkSubRegions(region_3)} /><Typography size={16} lineHeight={24}>{region_3.name}</Typography></label></li>;
    });
    $[0] = hideRegionAllOption;
    $[1] = regionList;
    $[2] = selectedRegion;
    $[3] = selectedSubRegions;
    $[4] = setSelectedSubRegions;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[15] !== t2 || $[16] !== t3) {
    t5 = <ul className={t2}>{t3}</ul>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <main className={t4}>{t5}</main>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default RegionModalContent;
function _temp(regions, region_0) {
  return regions.some(item => item.id === region_0.id);
}